import { useEffect, useState, useRef } from "react";
import "./ReceptionHeader.css";
import { Datetime } from "../Datetime/Datetime";
import EventsService from "../../services/EventsService";
import { useSSEContext } from "../../contexts/sse";
import { useUserStore } from "../../contexts/userStore";
import { TbDoor } from "react-icons/tb";
import { TriangleAlert, Users } from "lucide-react";
import { GoArrowSwitch } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { AnimatedTabbar, AnimatedTabbarItem } from "../AnimatedTabbar/AnimatedTabbar";
import { useTranslation } from "react-i18next";
import PageTitle from "../PageTitle/PageTitle";

export const ReceptionHeader = (props) => {
   const { selectedTab, setSelectedTab } = props;
   const { sseReceived } = useSSEContext();
   const { selectedCondominio } = useUserStore();
   const [totaPendingAlarms, setTotalPendingAlarms] = useState(0);
   const navigate = useNavigate();
   const cancelTokenRef = useRef(null);
   const { t } = useTranslation();

   async function loadTotalPendingAlarms() {
      if (cancelTokenRef.current) {
         cancelTokenRef.current.abort();
      }
      cancelTokenRef.current = new AbortController();
      const response = await EventsService.getCountPendingAlarms(selectedCondominio, cancelTokenRef.current.signal);
      setTotalPendingAlarms(response.data);
   }

   useEffect(() => {
      loadTotalPendingAlarms();
   }, [selectedCondominio]);

   useEffect(() => {
      if (["deviceBatchEventsConfirmation", "deviceBatchEventsDelete"].includes(sseReceived?.action)) {
         loadTotalPendingAlarms();
         return;
      }
      if (["deviceEventConfirmation", "createEvent"].includes(sseReceived?.action)) {
         if (sseReceived?.content?.type === "Alarme" && sseReceived?.content?.alarm_confirmation === null) {
            setTotalPendingAlarms(prevCount => prevCount + 1);
         }
         if (sseReceived?.content?.type === "Alarme" && sseReceived?.content?.alarm_confirmation !== null) {
            setTotalPendingAlarms(prevCount => prevCount - 1);
         }
      }
   }, [sseReceived]);

   return (
      <div className="reception-header">
         <div style={{ width: "70%" }}>
            <div className="reception-header-upper-container">
               <PageTitle
                  title={props.title}
                  icon={props.icon}
               />
            </div>
            <div className="reception-header-lower-container">
               <AnimatedTabbar
                  value={selectedTab}
                  className={`border-none!`}
                  onChange={value => navigate(`../monitoramento/${value}`)}
               >
                  <AnimatedTabbarItem name="portaria">
                     <span><TbDoor size={15} /></span>
                     <span>{t("monitoring.guardhouse")}</span>
                  </AnimatedTabbarItem>
                  <AnimatedTabbarItem name="alarmes">
                     <span><TriangleAlert size={15} /></span>
                     <span>{t("monitoring.alerts")}</span>
                     {totaPendingAlarms > 0 && <span className="badge-count">{totaPendingAlarms}</span>}
                  </AnimatedTabbarItem>
                  <AnimatedTabbarItem name="permanencia">
                     <span><Users size={15} /></span>
                     <span>{t("monitoring.presence")}</span>
                  </AnimatedTabbarItem>
                  <AnimatedTabbarItem name="acessos">
                     <span><GoArrowSwitch size={15} /></span>
                     <span>{t("monitoring.accesses")}</span>
                  </AnimatedTabbarItem>
               </AnimatedTabbar>
            </div>
         </div>
         <div style={{ width: "30%" }}>
            <Datetime />
         </div>
      </div>
   );
};